import React from 'react';
import Typography from '@material-ui/core/Typography';

import { BaseDatePicker, BaseDatePickerProps } from '../BaseDatePicker';
import { DateField } from './DateField';
import { CustomToolbar, CustomToolbarProps } from './CustomToolbar';
import { useStyles } from './styles';
import i18n from 'locales/i18n';

type CustomDatePickerProps = BaseDatePickerProps &
  CustomToolbarProps & {
    labelFormat?: string;
  };

export const CustomDatePicker = ({ title, labelFormat, ...restProps }: CustomDatePickerProps) => {
  const direction = i18n.dir()

  const classes = useStyles({ direction });

  const toolbar = React.useCallback(() => <CustomToolbar title={title} />, [title]);

  const { value } = restProps;

  const dateField = React.useCallback(
    (props: unknown) => <DateField {...props} value={value} labelFormat={labelFormat} />,
    [labelFormat, value]
  );

  return (
    <div className={classes.datePickerWrapper}>
      {title && (
        <Typography variant="body1" color="primary" className={classes.title}>
          {title}
        </Typography>
      )}
      <BaseDatePicker
        disableFuture
        format="yyyy-MM-dd"
        TextFieldComponent={dateField}
        ToolbarComponent={toolbar}
        {...restProps}
      />
    </div>
  );
};
